<template>
  <wrapper>
    <loading-screen :isActive="isLoading">
      <main class="main-content-wrapper">
        <employee-form @submit="handleSubmitData" />
      </main>
    </loading-screen>
  </wrapper>
</template>

<script>
import EmployeeForm from "./Components/Form.vue";
import { Wrapper, LoadingScreen } from "../Layout";
import { alert } from "../../utils";

export default {
  name: "CreateEmployee",
  components: {
    EmployeeForm,
    Wrapper,
    LoadingScreen,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async handleSubmitData(data) {
      this.isLoading = true;
      try {
        const response = await this.$http.post(
          process.env.CREATE_EMPLOYEE,
          data,
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        );
        if (response.data.status == 200) {
          alert()
            .fire({
              title: "Success",
              text: `${data.fullName} data has been successfully saved`,
              icon: "success",
              confirmButtonText: "Okay",
            })
            .then(() => {
              this.$router.push({
                path: "/employee/search",
                query: {
                  employeeName: "",
                  employeeEmail: "",
                  userType: "",
                  division: "",
                  page: 1,
                },
              });
            });
        } else {
          alert({ confirmButtonColor: "red" }).fire({
            title: "Failed",
            text:
              response.data.message ||
              `${data.fullName} data has been failed to save`,
            icon: "error",
            confirmButtonText: "Okay",
          });
        }
      } catch (error) {
        if (error.response) {
          return alert({ confirmButtonColor: "red" })
            .fire({
              title: "Failed",
              text: error.response.data.message,
              icon: "error",
              confirmButtonText: "Okay",
            })
            .then(() => {
              if (error.response.data.status == 401) {
                // this.handleLogout();
              }
            });
        }
        alert({ confirmButtonColor: "red" }).fire({
          title: "Failed",
          text: error.message,
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.main-content-wrapper {
  padding: 2rem 8rem;
}
</style>


// WEBPACK FOOTER //
// src/components/Employee/CreateEmployee.vue